/** An endpoint's user-facing name: its alias when set, otherwise its hostname. */
export function endpointDisplayName(endpoint: { hostname: string; alias?: string | null }): string {
  return endpoint.alias?.trim() || endpoint.hostname;
}
